import { Controller } from "@hotwired/stimulus";

class CountdownTimer {
  constructor({ selector, targetDate }) {
    this.selector = selector;
    this.targetDate = targetDate || new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Stockholm' }));
    this.refs = {
      days: document.querySelector(`${this.selector} [data-js-countdown-type="days"]`),
      hours: document.querySelector(`${this.selector} [data-js-countdown-type="hours"]`),
      minutes: document.querySelector(`${this.selector} [data-js-countdown-type="minutes"]`),
      seconds: document.querySelector(`${this.selector} [data-js-countdown-type="seconds"]`),
    };
  }
  getTimeRemaining(endtime) {
    const total = Date.parse(endtime) - Date.parse(new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Stockholm' })));
    const days = Math.floor(total / (1000 * 60 * 60 * 24));
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const seconds = Math.floor((total / 1000) % 60);
    return { total, days, hours, minutes, seconds };
  }

  updateTimer({ days, hours, minutes, seconds }) {
    const values = {
      days: Array.from(String(days).padStart(2, 0)),
      hours: Array.from(String(hours).padStart(2, 0)),
      minutes: Array.from(String(minutes).padStart(2, 0)),
      seconds: Array.from(String(seconds).padStart(2, 0)),
    };

    if (values.days.length === 3) {
      this.refs.days.innerHTML = `<span>${values.days[0]}</span><span>${values.days[1]}</span><span>${values.days[2]}</span>`;
    } else {
      this.refs.days.innerHTML = `<span>${values.days[0]}</span><span>${values.days[1]}</span>`;
    }
    this.refs.hours.innerHTML = `<span>${values.hours[0]}</span><span>${values.hours[1]}</span>`;
    this.refs.minutes.innerHTML = `<span>${values.minutes[0]}</span><span>${values.minutes[1]}</span>`;
    this.refs.seconds.innerHTML = `<span>${values.seconds[0]}</span><span>${values.seconds[1]}</span>`;
  }

  startTimer() {
    const timer = this.getTimeRemaining(this.targetDate);
    if (timer.days > 0 || timer.hours > 0 || timer.minutes > 0 || timer.seconds > 0) {
      this.updateTimer(timer);
      const x = setInterval(() => {
        const timer = this.getTimeRemaining(this.targetDate);
        if (timer.total < 0) clearInterval(x);
        this.updateTimer(timer);
      }, 1000);
    }
  }
}

export default class extends Controller {
  connect() {
    const elements = document.querySelectorAll('div.countdown');
    for (let i = 0; i < elements.length; i++) {
      if (!elements[i].id) elements[i].setAttribute('id', `countdown_${i+1}`);
      elements[i].setAttribute('name', `countdown_${i+1}`);
      const timer = new CountdownTimer({
        selector: `#${elements[i].id}`,
        targetDate: new Date(elements[i].dataset.jsCountdownDate),
      });
      timer.startTimer();
    }
  }
}
